export const REST = "rest";
export const WEBSOCKET = "websocket";
export const API_DOMAIN = "apiDomain";
export const NAME = "name";
export const BASE_PATH = "basePath";
export const ALERT_SEVERITY = "alertSeverity";
export const ALERT_SEVERITY_OPTIONS = ["P1", "P2", "P3"];
export const DEV = process.env.REACT_APP_ENVIRONMENT_NAME === "dev";
export const NON_PROD = process.env.REACT_APP_ENVIRONMENT_NAME !== "prod";
